import { DELETE_ITEM_MBQ_MOQ, DELETE_ITEM_MBQ_MOQ_SUCCESS, GET_ITEM_MBQ_MOQ, GET_ITEM_MBQ_MOQ_SUCCESS, ITEM_MBQ_MOQ_ERROR, RESET_ITEM_MBQ_MOQ_STATE, SAVE_ITEM_MBQ_MOQ, SAVE_ITEM_MBQ_MOQ_SUCCESS } from "./actionType";


// 🔹 GET
export const getItemMBQMOQ = (config = {}) => ({
  type: GET_ITEM_MBQ_MOQ,
  config,
});

export const getItemMBQMOQSuccess = (data) => ({
  type: GET_ITEM_MBQ_MOQ_SUCCESS,
  payload: data,
});

// 🔹 SAVE (POST)
export const saveItemMBQMOQ = (config = {}) => ({
  type: SAVE_ITEM_MBQ_MOQ,
  config,
});

export const saveItemMBQMOQSuccess = (resp) => ({
  type: SAVE_ITEM_MBQ_MOQ_SUCCESS,
  payload: resp,
});

// 🔹 DELETE
export const deleteItemMBQMOQ = (config = {}) => ({
    type: DELETE_ITEM_MBQ_MOQ,   // correct
    config,
  });

export const deleteItemMBQMOQSuccess = (resp) => ({
  type: DELETE_ITEM_MBQ_MOQ_SUCCESS,
  payload: resp,
});

// 🔹 RESET
export const resetItemMBQMOQState = () => ({
  type: RESET_ITEM_MBQ_MOQ_STATE,
});

// 🔹 ERROR
export const itemMBQMOQError = () => ({
  type: ITEM_MBQ_MOQ_ERROR,
});